/* eslint-disable */
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import Select from 'react-select';
import * as actions from '../action';
import * as c from '../constant';

function CreateModal({
  createCedulaFees,
  getNewOtherFeesList,
  history,
  getSingleNewOtherFees,
  getCedulaCalculationList,
  creating,
  ordinanceRevisionId,
  newOtherFeesId,

  cedulaCalculationList,
}) {
  const [formData, setFormData] = useState({
    business_type: '',
    cedula_fixed_fee: '',
    cedula_base_fee: '',
    cedula_for_every_fee: '',
    cedula_additional_fee: '',
    cedula_max_fee: ''
  });

  const validateForm = useFormValidator(formData, {
    business_type: 'required',
    cedula_fixed_fee: 'required',
    cedula_base_fee: 'required',
    cedula_for_every_fee: 'required',
    cedula_additional_fee: 'required',
    cedula_max_fee: 'required'
  });

  const setModal = useContext(ModalContext);

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      ...formData,
      business_type: _.get(formData, 'business_type').toUpperCase(),
    };

    createCedulaFees(newOtherFeesId, args, () => {
      setModal({ isOpen: false });
      getNewOtherFeesList({ ordinance_revision_id: ordinanceRevisionId });
      history.push(`/bpls/tax-revenue/new-other-fees/${newOtherFeesId}`);
      getSingleNewOtherFees(newOtherFeesId);
      getCedulaCalculationList(newOtherFeesId);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // check the first there's an existing business type then retun object of data, if no existing business type available, return {}
  const checkBusinessTypeData = selectedBusinessType => cedulaCalculationList.find(type => type.attributes.business_type === selectedBusinessType) || {}

  const handleOnChangeSelect = key => e => {

    if (!_.isEmpty(checkBusinessTypeData(e.value))) {
      setFormData({
        ...formData,
        [key]: e ? e.value : '',
        cedula_fixed_fee: _.get(checkBusinessTypeData(e.value), "attributes.cedula_fixed_fee"),
        cedula_base_fee: _.get(checkBusinessTypeData(e.value), "attributes.cedula_base_fee"),
        cedula_for_every_fee: _.get(checkBusinessTypeData(e.value), "attributes.cedula_for_every_fee"),
        cedula_additional_fee: _.get(checkBusinessTypeData(e.value), "attributes.cedula_additional_fee"),
        cedula_max_fee: _.get(checkBusinessTypeData(e.value), "attributes.cedula_max_fee"),
      })
    }

    if (_.isEmpty(checkBusinessTypeData(e.value))) {
      setFormData({
        ...formData,
        [key]: e ? e.value : '',
        cedula_fixed_fee: '',
        cedula_base_fee: '',
        cedula_for_every_fee: '',
        cedula_additional_fee: '',
        cedula_max_fee: '',
      });
    }
  };

  const listBusinessTypeOptions = c.BUSINESS_TYPE.map((businessType) => ({
    label: _.get(businessType, 'label'),
    value: businessType.value,
  }));

  const selectedBusinessType = [];
  cedulaCalculationList.map((item) =>
    selectedBusinessType.push(_.get(item, 'attributes.business_type'))
  );

  const filteredBusinessType = _.filter(
    listBusinessTypeOptions,
    (v) => !_.includes(selectedBusinessType, v.label) && (v.label === 'CORPORATION' || v.label === 'SOLE PROPRIETORSHIP')
  );

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Business Type:
              {validateForm.renderMessage('business_type')}
            </label>
            <Select
              name="business_type"
              placeholder="Select Business Type"
              onChange={handleOnChangeSelect('business_type')}
              options={filteredBusinessType}
              value={
                c.BUSINESS_TYPE.find(
                  item =>
                    _.get(formData, 'business_type') ===
                    _.get(item, 'value')
                ) || ''
              }
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Fixed Fee: {validateForm.renderMessage('cedula_fixed_fee')}
            </label>
            <input
              className="form-control"
              type="number"
              name="cedula_fixed_fee"
              // disabled={_.get(formData, 'cedula_fixed_fee') !== ""}
              disabled={!_.isEmpty(checkBusinessTypeData(_.get(formData, "business_type")))}
              onChange={onChange}
              placeholder="Ex. 1.00"
              value={_.get(formData, 'cedula_fixed_fee')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Base Fee: {validateForm.renderMessage('cedula_base_fee')}
            </label>
            <input
              className="form-control"
              type="number"
              name="cedula_base_fee"
              disabled={!_.isEmpty(checkBusinessTypeData(_.get(formData, "business_type")))}
              onChange={onChange}
              placeholder="Ex. 1.00"
              value={_.get(formData, 'cedula_base_fee')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              For Every Fee: {validateForm.renderMessage('cedula_for_every_fee')}
            </label>
            <input
              className="form-control"
              type="number"
              name="cedula_for_every_fee"
              disabled={!_.isEmpty(checkBusinessTypeData(_.get(formData, "business_type")))}
              onChange={onChange}
              placeholder="Ex. 1.00"
              value={_.get(formData, 'cedula_for_every_fee')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Additional Fee: {validateForm.renderMessage('cedula_additional_fee')}
            </label>
            <input
              className="form-control"
              type="number"
              name="cedula_additional_fee"
              disabled={!_.isEmpty(checkBusinessTypeData(_.get(formData, "business_type")))}
              onChange={onChange}
              placeholder="Ex. 1.00"
              value={_.get(formData, 'cedula_additional_fee')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Max Fee: {validateForm.renderMessage('cedula_max_fee')}
            </label>
            <input
              className="form-control"
              type="number"
              name="cedula_max_fee"
              disabled={!_.isEmpty(checkBusinessTypeData(_.get(formData, "business_type")))}
              onChange={onChange}
              placeholder="Ex. 1.00"
              value={_.get(formData, 'cedula_max_fee')}
            />
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={creating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary     mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>{' '}
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateModal.propTypes = {
  getNewOtherFeesList: PropTypes.instanceOf(Function).isRequired,
  createCedulaFees: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleNewOtherFees: PropTypes.instanceOf(Function).isRequired,
  getCedulaCalculationList: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
  newOtherFeesId: PropTypes.string.isRequired,

  cedulaCalculationList: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  creating: api.loading.indexOf(c.CREATE_CEDULA_FEES) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateModal);
